import { render, staticRenderFns } from "./CorrespondenceSalutationCreate.vue?vue&type=template&id=5e58ed72"
import script from "./CorrespondenceSalutationCreate.vue?vue&type=script&lang=js"
export * from "./CorrespondenceSalutationCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports